import { createSlice } from "@reduxjs/toolkit";

const initialGlobalState = {
  country: null,
  isMobile: false,
  steamUrl: "",
};

const globalSlice = createSlice({
  name: "global",
  initialState: initialGlobalState,
  reducers: {
    setCountry(state, action) {
      state.country =
        typeof action.payload !== "undefined" ? action.payload : "default";
      return state;
    },
    setIsMobile(state, action) {
      state.isMobile =
        typeof window !== "undefined" && window.innerWidth <= 768;
      return state;
    },
    setSteamUrl(state, action) {
      state.steamUrl =
        typeof action.payload !== "undefined" ? action.payload : "";
      return state;
    },
  },
});

export const globalActions = globalSlice.actions;

export default globalSlice.reducer;
